<template>
<FormCompound class="form-discount-rules">
<template v-if="type=='percent'">
  <FormInput v-model="componentValue.discountPercent" placeholder="Procenat popusta" class="form-input-decimal" />
  <label>%</label>
  <FormInput v-model="componentValue.minValue" placeholder="Minimalna vrednost" class="form-input-decimal" />
  <label>{{ currentCurrency }}</label>
</template>
<template v-if="type=='fixed'">
  <FormInput v-model="componentValue.discountAmount" placeholder="Vrednost popusta" class="form-input-decimal" />
  <label>{{ currentCurrency }}</label>
  <FormInput v-model="componentValue.minValue" placeholder="Minimalna vrednost" class="form-input-decimal" />
  <label>{{ currentCurrency }}</label>
</template>
<template v-if="type=='fixedproduct'">
  <FormInput v-model="componentValue.discountAmount" placeholder="Vrednost popusta" class="form-input-decimal" />
  <label>{{ currentCurrency }}</label>
  <FormInput v-model="componentValue.minValue" placeholder="Minimalna cena" class="form-input-decimal" />
  <label>{{ currentCurrency }}</label>
</template>
<template v-if="type=='percent2'">
  <FormInput v-model="componentValue.discountPercent" placeholder="Procenat popusta drugog proizvoda" class="form-input-decimal" />
  <label>%</label>
</template>
<template v-if="type=='fixed2'">
  <FormInput v-model="componentValue.fixedPrice" placeholder="Cena drugog proizvoda" class="form-input-decimal" />
  <label>{{ currentCurrency }}</label>
</template>
</FormCompound>
</template>

<script>
export default {
  props: ["modelValue", "item", "typeField"],
  data: ()=>({
    componentValue: {},
  }),
  computed: {
    currentCurrency() {
      return "RSD"; // TODO
    },
    type() {
      return this.item?.[this.typeField];
    },
  },
  watch: {
    modelValue: {
      handler() {
        this.componentValue=this.modelValue || {};
      }, immediate: true,
    },
    componentValue: {
      handler () {
        if (JSON.stringify(this.componentValue)!=JSON.stringify(this.modelValue))
          this.$emit("update:modelValue", this.componentValue);
      }, deep: true,
    }
  },
}
</script>
